import ResolveImage from './ResolveImage.component';

export default ResolveImage;